module.exports = {
    isTablePlaceholder() {
        return this.isPlaceholder() && this.placeholderType === 'TABLE';
    }
};
